import axios from 'axios';
import { logout } from '../store/slices/authSlice';
import { store } from '../store';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMessage = error.response?.data?.detail || '';
    
    // Handle 401 or "Could not validate credentials" error
    if (
      error.response?.status === 401 || 
      errorMessage === 'Could not validate credentials' ||
      errorMessage.includes('Could not validate credentials')
    ) {
      // Dispatch logout action to clear Redux state
      store.dispatch(logout());
      
      // Redirect to login
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
